import { render, staticRenderFns } from "./health-notice.vue?vue&type=template&id=232c121b&scoped=true&"
import script from "./health-notice.vue?vue&type=script&lang=js&"
export * from "./health-notice.vue?vue&type=script&lang=js&"
import style0 from "./health-notice.vue?vue&type=style&index=0&id=232c121b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c121b",
  null
  
)

export default component.exports